module.exports = __webpack_public_path__ + "static/scale-model-of-ulistac-natural-area-in-fremont-california-ca897305af559e421375a6a67bdb74a8.png";